import { Routes } from '@angular/router';
import { waitingRoomGuard } from '../../guards/waiting-room.guard';
import { preferredPharmacyRoutes } from '@features/preferred-pharmacy/preferred-pharmacy.routes';

export const waitingRoomRoutes: Routes = [
  {
    path: '',
    canActivate: [waitingRoomGuard],
    data: {
      background: 'assets/splash_bck.png',
    },
    loadComponent: () => import('./waiting-room.page').then((m) => m.WaitingRoomPage),
  },
  {
    path: 'pre-video-visit',
    loadComponent: () => import('./components/pre-visit/pre-visit.page').then((m) => m.PreVisitPage),
    data: {
      background: 'assets/splash_bck.png',
    },
  },
  {
    path: 'schedule-confirmation',
    loadComponent: () =>
      import('./components/schedule-confirmation/waiting-room-schedule-confirmation.page').then(
        (m) => m.WaitingRoomScheduleConfirmation,
      ),
    data: {
      background: 'assets/splash_bck.png',
    },
  },
  {
    path: 'pharmacy',
    children: preferredPharmacyRoutes,
    data: {
      background: 'assets/splash_bck.png',
    },
  },
];
